import { createContext, useContext } from 'react';

export interface WidgetConfigContextValue {
  widgetIsOnConfig: boolean;
}

export const WidgetConfigContext = createContext<WidgetConfigContextValue>({
  widgetIsOnConfig: false,
});

export function useWidgetConfigContext(): WidgetConfigContextValue {
  return useContext(WidgetConfigContext);
}
